import { render } from "./BusinessResources.vue?vue&type=template&id=00e2d2d9"
import script from "./BusinessResources.vue?vue&type=script&lang=js"
export * from "./BusinessResources.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__